import { useQuery } from '@maui/react-query'
import { useMatiApiClient } from './client'

export const useMalwareQuery = (id, options = {}) => {
  const api = useMatiApiClient('malware')
  return useQuery({
    queryFn: () => api.fetchMalwareById(id),
    queryKey: ['malware', id],
    refetchOnWindowFocus: false,
    ...options
  })
}

export const useMostActiveMalwareQuery = ({ limit, startEpoch }, options = {}) => {
  const api = useMatiApiClient('malware')
  const body = { limit, start_epoch: startEpoch }

  return useQuery({
    queryFn: () => api.fetchMostActiveMalware(body),
    queryKey: ['mostActiveMalware', body],
    ...options,
  })
}
